import { getFromStorage } from '../Storage';
import cleanseNumber from '../../../modules/cleansePositiveNumber';

export default function() {
    let term = cleanseNumber(getFromStorage('used.term'), false);
    let deposit = cleanseNumber(getFromStorage('used.deposit'), false);
    let mileage = cleanseNumber(getFromStorage('used.mileage'), false);
    let payment = cleanseNumber(getFromStorage('used.payment'), false);
    return {
        term: term,
        deposit: deposit,
        mileage: mileage,
        payment: payment,
    };
}